<template>
  <div class="nav-footer">
    <div class="w">
      <!-- 导航列表 -->
      <div class="f-list">
        <div class="w">
          <a href="/">网站首页</a> 
          <span>-</span> <a href="/#/info">关于我们</a> 
       
          <span>-</span>
          <a href="/#/zw2">纠纷处理</a> 
          <span>-</span>
          <a href="/#/jf">用户协议</a> 
        </div>
      </div>
      <div class="f-list">
        <div class="w">
          <a href="https://www.shdf.gov.cn/shdf/channels/740.html">扫黄打非入口</a>
          <span>-</span>
          <a href="https://www.12377.cn/">举报专区</a>
          
          
          <!-- <a href="/imgs/zz.jpg" target="_blink">营业执照</a> -->
          <span>-</span>
          <a href="http://cyberpolice.mps.gov.cn/wfjb/">网络110报警服务</a> 
         
        </div>
      </div>
      <div class="f-list">
        <div class="w">
          <a href="https://www.12377.cn/">中国互联网举报中心</a>
          <span>-</span>
          <a href="https://www.12377.cn/jbxzxq/zpljbxzxq.html?spm=zm1033-001.0.0.1.SOXBdI">电信诈骗举报</a>
          <span>-</span>
          <a href="https://www.12377.cn/node_548446.htm">网络举报APP下载</a>
          <span>-</span>
          <a href="https://jbts.mct.gov.cn/">全国文化和旅游市场网上举报投诉</a>

    
        </div>
      </div>

      <!-- 网站信息 -->
      <div class="f-info">
        <!-- 公司名称 -->
        <p>杭州含情网络技术有限公司</p>
        <p>公司电话：18858145124 -- 公司邮箱：4093082@qq.com</p>
        <p>注册地址：浙江省杭州市临平区乔司街道科城街180号1幢6层601-603、612、615-617室-54 </p>
      
        <p>
           © 2024 hanqingnet.com  版权保护声明 -- 
          <a href="https://beian.miit.gov.cn/#/Integrated/index"
            >ICP备案/许可证号：浙ICP备2024077042号-1</a>
          
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-header",
  props: {},
  data(){
    return {
      // 网页的基础数据配置
      dataSourc:{}
    }
  },
  mounted() {
     // 查询网站基本配置数据
      this.axios.get("http://8.142.155.68:8099/api/data/sourc/selectAll").then((res) => {
        this.dataSourc = res.data[0]
      });

  }
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.nav-footer {
  width: 100%;
  background-color: #ececec;
  .w {
    text-align: center;
    box-sizing: border-box;
    padding: 20px;
    width: 1226px;
    margin: 0 auto;
    // 上层
    .f-list {
      width: 100%;
      display: flex;
      align-items: center;
      height: 30px;
      a {
        // color: #888;
        color: #333;
        // font-weight: bold;
        font-size: 14px;
      }
      span {
        margin: 0 5px;
        color: #333;
        // font-weight: bold;
      }
    }

    // 信息层
    .f-info {
      p {
        // color: #888;
        margin: 10px 0;
         color: #333;
          // font-weight: bold;
          font-size: 14px;
        a {
          // color: #888;
          color: #333;
          // font-weight: bold;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
